import * as reducers from './reducers';
import * as actions from './actions';
import * as hooks from './hooks';
/**
 * Encapsulates all common functionality regarding Lucina subscribers.
 *
 * This will allow you to easily integrate email subscription functionality into your app.
 *
 * See the docs for each action, reducer, and hook for more information about what each piece of this model does as well as suggested usage.
 *
 * ```js
 * import { subscription } from '@minerva-analytics/pantheon;
 *
 * console.log(subscription);
 * {
 *   actions: {
 *     updateEmail,
 *     createSubscriber,
 *     confirmSubscriberStart,
 *     confirmSubscriberSuccess,
 *     confirmSubscriberFailure,
 *     confirmSubscriber,
 *   },
 *   reducers: {
 *     email,
 *     subscriberInfo,
 *     createSubscriberStatus,
 *     confirmSubscriberStatus,
 *   },
 *   hooks: {
 *     useSubscriptionActions
 *   }
 * }
 * ```
 */

export var subscription = {
  actions: actions,
  reducers: reducers,
  hooks: hooks
};